import{parsePermissionString as e}from"./parse-permission-string.mjs";const t=t=>typeof t==`string`?e(t):t;export{t as parsePermission};
//# sourceMappingURL=parse-permission.mjs.map